<template>
  <div>
    <v-navigation-drawer class="elevation-1 border-0" v-model="drawer" app>
      <v-navigation-drawer v-model="drawer" app>
        <div class="text-center pa-5">
          <v-img src="/img/logo.png" contain height="100"></v-img>
          <h3 style="color: #01288d">Partner Dashboard</h3>
        </div>

        <v-list
          dense
          style="font-family: 'Montserrat', sans-serif; font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.19;"
        >
          <v-subheader>
            <v-icon v-if="drawer" @click="drawer = false">mdi-menu</v-icon>
          </v-subheader>
          <v-list-item-group color="white" active-class="primary">
            <v-list-item
              v-for="item in items"
              :key="item.title"
              :to="item.to"
              exact
              light
              class="pa-3"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </v-navigation-drawer>

    <v-app-bar height="100" app light color="white">
      <v-btn
        color="white"
        light
        fab
        elevation="1"
        dark
        x-small
        icon
        @click="drawer = true"
        style="margin: 0 1rem"
        v-if="!drawer"
      >
        <v-icon color="primary">
          mdi-menu
        </v-icon>
      </v-btn>

      <!-- <v-toolbar-title class="primary--text">{{ $route.name }}</v-toolbar-title> -->

      <v-spacer />

      <!-- <v-icon>mdi-bell-outline</v-icon> -->
      <div>
        <span>{{ user.email }}</span>
        <v-icon
          style="padding: .6rem; background-color: #fed400; border-radius: 50%;  margin-left: 1rem; margin-right: 1rem"
        >
          mdi-account-circle-outline</v-icon
        >
      </div>

      <v-menu
        class="mx-2"
        transition="slide-y-transition"
        bottom
        offset-y
        offset-x
        rounded="0"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical </v-icon>
        </template>
        <v-list dense>
          <v-subheader>Account</v-subheader>
          <v-list-item-group color="primary">
            <v-list-item @click="logout">
              <v-list-item-icon>
                <v-icon>mdi-export</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="updateProfile">
              <v-list-item-icon>
                <v-icon>mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Profile</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <!-- Content-->
      <router-view
        v-if="$route.name == 'DashboardRegister'"
        class="dashboard-custom pl-md-16 pr-md-16"
        style="min-height: 90vh; background-color: #01288d"
      />

      <router-view
        v-else-if="$route.name == 'DashboardFinish'"
        class="dashboard-custom pl-md-16 pr-md-16"
        style="min-height: 90vh; background-color: #01288d"
      />
      <router-view
        v-else-if="$route.name == 'DashboardStart'"
        class="dashboard-custom pa-0 pl-md-16 pr-md-16"
        style="min-height: 90vh; background-color: #01288d"
      />
      <router-view v-else class="pl-md-16 pr-md-16" style="min-height: 80vh;" />
    </v-main>
    <v-overlay opacity="0.5" :value="loading">
      <v-progress-circular indeterminate size="64">
        Loading...
      </v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { AuthService } from "../../modules/auth";

export default {
  name: "dashboard",
  data: () => ({
    drawer: null,
    loading: false,

    items: [
      {
        to: "/dashboard",
        title: "Dashboard",
        icon: "mdi-gauge-low"
      },
      {
        to: "/dashboard/drivers",
        title: "Drivers",
        icon: "mdi-account-tie"
      },
      {
        to: "/dashboard/vehicles",
        title: "Vehicles",
        icon: "mdi-car-outline"
      },
      {
        to: "/dashboard/payments",
        title: "Payments",
        icon: "mdi-cash-multiple"
      }
    ]
  }),
  computed: {
    user() {
      return AuthService.user;
    },
    currentRouteName() {
      return this.$route.name;
    }
  },
  methods: {
    logout: function() {
      AuthService.logout();
    },

    updateProfile: function() {
      this.$router.push({ name: "DashboardRegister" });
    }
  },

  mounted() {
    Event.$on("loading", value => {
      this.loading = value;
    });
  }
};
</script>

<style>
.v-sheet.v-app-bar.v-toolbar:not(.v-sheet--outlined) {
  box-shadow: none !important;
}

v-sheet.v-toolbar:not(.v-sheet--outlined) {
  box-shadow: none !important;
}

.v-list--dense .v-list-item .v-list-item__title,
.v-list--dense .v-list-item .v-list-item__subtitle {
  font-size: 0.9rem !important;
  font-weight: 600 !important;
}

.dashboard-custom.container {
  max-width: 100% !important;
}
</style>
